module.exports = __webpack_public_path__ + "img/logo.b7171f57.png";